const BANK_CONNECTION_API_PATHS = new Set(['getModifyUrl']);

const MESSAGES = {
  quotaWithDate: {
    fr: (time) =>
      `Vous avez atteint le nombre de reconnexions autorisées pour cette banque. Nouvelle tentative possible à partir de ${time}.`,
    en: (time) =>
      `You have reached the number of reconnections allowed for this bank. You can try again from ${time}.`,
  },
  quota: {
    fr: 'Vous avez atteint le nombre de reconnexions autorisées pour cette banque. Réessayez dans quelques heures.',
    en: 'You have reached the number of reconnections allowed for this bank. Please try again in a few hours.',
  },
  unavailable: {
    fr: "La configuration de cette connexion bancaire n'est pas disponible pour le moment.",
    en: 'The configuration of this bank connection is not available right now.',
  },
};

function normalizeLocale(locale) {
  return locale === 'en' ? 'en' : 'fr';
}

function formatNextAttempt(nextAttemptAt, locale) {
  if (!nextAttemptAt) return null;
  const date = new Date(nextAttemptAt);
  if (Number.isNaN(date.getTime())) return null;
  return date.toLocaleString(locale === 'en' ? 'en-GB' : 'fr-FR', {
    weekday: 'long',
    hour: '2-digit',
    minute: '2-digit',
  });
}

export function isBankConnectionApi(api) {
  return typeof api === 'string' && BANK_CONNECTION_API_PATHS.has(api);
}

export function resolveBankConnectionErrorMessage({api, error, locale} = {}) {
  if (!isBankConnectionApi(api)) return null;
  const loc = normalizeLocale(locale);

  if (
    error?.status === 429 ||
    error?.message === 'reconnection_quota_reached'
  ) {
    const time = formatNextAttempt(error?.result?.next_attempt_at, loc);
    return time ? MESSAGES.quotaWithDate[loc](time) : MESSAGES.quota[loc];
  }

  return MESSAGES.unavailable[loc];
}
